// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-title {
  font-family: var(--font);
  font-weight: 600;
  font-size: 16px;
}

.details {
  font-family: var(--font);
  font-weight: 300;
  font-size: 16px;
}

.time {
  font-family: var(--font);
  font-weight: 300;
  font-size: 12px;
}

.notification-msg {
  font-weight: 300;
  font-size: 0.72em;
}

.notification-title-detail {
  font-weight: bold;
  font-family: var(--font);
  font-weight: 600;
}

.notification-msg-detail {
  font-weight: 400;
  font-size: 1em;
  font-family: var(--font);
  font-weight: 400;
  margin: 8px 0;
}

.highlight-pic {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.detail-container {
  padding: 3% 5%;
}

.background {
  min-height: 93vh !important;
}

ion-item {
  --border-color: none;
  --border-size: 0;
  --border-style: none;
}

.badge {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  height: 12px;
  width: 12px;
  border-radius: 15px;
  margin: 0.5rem;
  background-color: #eb266a;
}

.read {
  --background: #e6e6e6;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/notifications/notifications.component.scss"],"names":[],"mappings":"AAAA;EACI,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;AAEJ;;AAAA;EACI,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;AAIJ;;AAFA;EACI,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;AAMJ;;AAJA;EACI,gBAAA;EACA,iBAAA;AAOJ;;AAJA;EACI,iBAAA;EAEA,wBAAA;EAA0B,gBAAA;AAO9B;;AAJA;EACI,gBAAA;EACA,cAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,aAAA;AAQJ;;AALA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;AAQJ;;AANA;EACI,cAAA;AASJ;;AAPA;EACI,2BAAA;AAUJ;;AAPA;EACI,oBAAA;EACA,gBAAA;EACA,oBAAA;AAUJ;;AAPA;EACI,cAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;AAUJ;;AAPA;EACI,qBAAA;AAUJ","sourcesContent":[".notification-title {\n    font-family: var(--font); font-weight: 600;;\n    font-size: 16px;\n}\n.details{\n    font-family: var(--font); font-weight: 300;;\n    font-size: 16px;\n}\n.time{\n    font-family: var(--font); font-weight: 300;;\n    font-size: 12px;\n}\n.notification-msg {\n    font-weight: 300;\n    font-size: .72em;\n}\n\n.notification-title-detail {\n    font-weight: bold;\n    // font-size: 1.2em;\n    font-family: var(--font); font-weight: 600;;\n}\n\n.notification-msg-detail {\n    font-weight: 400;\n    font-size: 1em;\n    font-family: var(--font); font-weight: 400;;\n    margin: 8px 0;\n}\n\n.highlight-pic {\n    width: 100%;\n    height: 100%;\n    object-fit: fill;\n}\n.detail-container{\n    padding: 3% 5%;\n}\n.background{\n    min-height: 93vh !important;\n}\n// ion-item:last-child\nion-item {\n    --border-color: none;\n    --border-size: 0;\n    --border-style: none;\n}\n\n.badge {\n    display: block;\n    position:absolute;\n    top: 0;\n    right: 0;\n    height: 12px;\n    width: 12px;\n    border-radius: 15px;\n    margin: 0.5rem;\n    background-color: #eb266a;\n}\n\n.read {\n    --background: #e6e6e6;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
